import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, ProgressBar } from 'react-bootstrap';

const VacationSummary = ({ calculoVacaciones, perfil, formatDate }) => {
    return (
        <div className="border rounded-3 p-3 bg-light">
            <h6 className="mb-3">
                <FontAwesomeIcon icon="calendar-check" className="me-2 text-primary" />
                D&iacute;as de Vacaciones
            </h6>

            {/* Resumen de días */}
            <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted">Total acumulado:</span>
                    <h4 className="mb-0 text-primary">{calculoVacaciones.diasTotales} d&iacute;as</h4>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted">D&iacute;as utilizados:</span>
                    <h4 className="mb-0 text-danger">{calculoVacaciones.diasUtilizados} d&iacute;as</h4>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold">Disponibles:</span>
                    <h3 className="mb-0 text-success">{calculoVacaciones.diasDisponibles} d&iacute;as</h3>
                </div>
            </div>

            {/* Información del empleado */}
            <div className="mb-3 p-2 bg-white rounded border">
                <small className="text-muted d-block mb-1">
                    <FontAwesomeIcon icon="briefcase" className="me-1 text-primary" />
                    <strong>Fecha de ingreso:</strong> {perfil.dFechaIngreso ? formatDate(perfil.dFechaIngreso) : 'No disponible'}
                </small>
                <small className="text-muted d-block mb-1">
                    <FontAwesomeIcon icon="clock" className="me-1 text-primary" />
                    <strong>A&ntilde;os de servicio:</strong> {calculoVacaciones.aniosServicio || 0}
                </small>
                <small className="text-muted d-block">
                    <FontAwesomeIcon icon="tag" className="me-1 text-primary" />
                    <strong>Categor&iacute;a:</strong> {perfil.vCategoria || 'No especificado'}
                </small>
            </div>

            {/* Desglose por período/año */}
            {calculoVacaciones.desglosePorAnio && calculoVacaciones.desglosePorAnio.length > 0 && (
                <div className="mt-3">
                    <h6 className="text-primary small fw-bold mb-3">
                        <FontAwesomeIcon icon="list-alt" className="me-2" />
                        Desglose por Per&iacute;odo de Servicio
                    </h6>
                    <div className="mt-2">
                        {calculoVacaciones.desglosePorAnio.map((periodo, index) => {
                            const esProporcional = periodo.iAnio === 0 || (periodo.bPeriodoActivo && !periodo.bPeriodoCompletado);
                            const porcentaje = periodo.decPorcentajeAvance || 0;
                            const esActivo = periodo.bPeriodoActivo;
                            const esCompletado = periodo.bPeriodoCompletado;
                            const tieneDiasDisponibles = periodo.iDiasDisponibles > 0;
                            
                            return (
                                <div 
                                    key={index} 
                                    className={`mb-3 p-3 rounded border ${
                                        esActivo ? 'bg-primary bg-opacity-10 border-primary' : 
                                        tieneDiasDisponibles ? 'bg-opacity-5 border-success' : 
                                        'bg-white'
                                    }`}
                                >
                                    <details>
                                        <summary className="cursor-pointer" style={{ cursor: 'pointer' }}>
                                            {/* Encabezado del período */}
                                            <div className="d-inline-flex justify-content-between align-items-center w-100">
                                                <div>
                                                    <h6 className="mb-0 d-inline">
                                                        {periodo.vDescripcionAnio || `Año ${periodo.anio}`}
                                                        {esActivo && (
                                                            <Badge bg="success" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                                                Activo
                                                            </Badge>
                                                        )}
                                                        {esCompletado && (
                                                            <Badge bg="secondary" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                                                Completado
                                                            </Badge>
                                                        )}
                                                        {tieneDiasDisponibles && esCompletado && (
                                                            <Badge bg="success" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                                                <FontAwesomeIcon icon="check-circle" className="me-1" />
                                                                Días Acumulados
                                                            </Badge>
                                                        )}
                                                    </h6>
                                                    <div>
                                                        <small className="text-muted">
                                                            {periodo.dFechaInicio} - {periodo.dFechaFin}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="text-end ms-auto">
                                                    <Badge 
                                                        bg={periodo.iDiasDisponibles > 0 ? 'success' : 'secondary'} 
                                                        pill
                                                        style={{ fontSize: '0.9rem' }}
                                                    >
                                                        {periodo.iDiasDisponibles} disponibles
                                                    </Badge>
                                                </div>
                                            </div>
                                        </summary>

                                        {/* Contenido expandible */}
                                        <div className="mt-3">
                                            {/* Barra de progreso si es período proporcional o activo */}
                                            {esProporcional && (
                                                <div className="mb-2">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <small className="text-muted">
                                                            <FontAwesomeIcon icon="hourglass-half" className="me-1" />
                                                            Avance del per&iacute;odo:
                                                        </small>
                                                        <small className="fw-bold text-primary">
                                                            {porcentaje.toFixed(1)}%
                                                        </small>
                                                    </div>
                                                    <ProgressBar 
                                                        now={porcentaje} 
                                                        variant="primary"
                                                        style={{ height: '8px' }}
                                                    />
                                                </div>
                                            )}

                                            {/* Detalles de días */}
                                            <div className="row g-2 mt-2">
                                                <div className="col-4">
                                                    <div className="text-center p-2 bg-light rounded">
                                                        <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                                                            Generados
                                                        </small>
                                                        <strong className="text-primary">
                                                            {periodo.iDiasGenerados}
                                                        </strong>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="text-center p-2 bg-light rounded">
                                                        <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                                                            Utilizados
                                                        </small>
                                                        <strong className="text-danger">
                                                            {periodo.iDiasUtilizados}
                                                        </strong>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="text-center p-2 bg-light rounded">
                                                        <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                                                            Disponibles
                                                        </small>
                                                        <strong className="text-success">
                                                            {periodo.iDiasDisponibles}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Mensaje informativo */}
                                            {esProporcional && esActivo && (
                                                <div className="mt-2">
                                                    <small className="text-muted fst-italic d-block">
                                                        <FontAwesomeIcon icon="info-circle" className="me-1 text-info" />
                                                        Los d&iacute;as se acumulan proporcionalmente mientras avanza el per&iacute;odo
                                                    </small>
                                                </div>
                                            )}
                                            
                                            {/* Mensaje de acumulación histórica */}
                                            {tieneDiasDisponibles && esCompletado && (
                                                <div className="mt-2">
                                                    <small className="text-success fst-italic d-block">
                                                        <FontAwesomeIcon icon="piggy-bank" className="me-1" />
                                                        Estos d&iacute;as est&aacute;n acumulados y disponibles para usar
                                                    </small>
                                                </div>
                                            )}
                                        </div>
                                    </details>
                                </div>
                            );
                        })}

                        {/* Total acumulado */}
                        <div className="mt-3 p-3 bg-primary bg-opacity-10 rounded border border-primary">
                            <div className="row g-2">
                                <div className="col-4 text-center">
                                    <small className="text-muted d-block mb-1">Total Generado</small>
                                    <h5 className="mb-0 text-primary">{calculoVacaciones.diasTotales}</h5>
                                </div>
                                <div className="col-4 text-center">
                                    <small className="text-muted d-block mb-1">Total Utilizado</small>
                                    <h5 className="mb-0 text-danger">{calculoVacaciones.diasUtilizados}</h5>
                                </div>
                                <div className="col-4 text-center">
                                    <small className="text-muted d-block mb-1">Total Disponible</small>
                                    <h5 className="mb-0 text-success">{calculoVacaciones.diasDisponibles}</h5>
                                </div>
                            </div>
                            
                            {/* Mensaje de acumulación histórica */}
                            <div className="mt-3 p-2 bg-success bg-opacity-10 rounded border border-success">
                                <small className="text-success d-block text-center fw-bold">
                                    <FontAwesomeIcon icon="star" className="me-1" />
                                    Acumulaci&oacute;n Hist&oacute;rica Activada
                                </small>
                                <small className="text-muted d-block text-center mt-1" style={{ fontSize: '0.75rem' }}>
                                    Puedes usar los {calculoVacaciones.diasDisponibles} d&iacute;as disponibles en cualquier momento.
                                    Los d&iacute;as del periodo actual se podr&aacute;n usar hasta el t&eacute;rmino del mismo, casos excepcionales, favor de revisarlo con tu supervisor.
                                </small>
                            </div>
                        </div>

                        <small className="text-muted fst-italic d-block mt-3 text-center">
                            <FontAwesomeIcon icon="scale-balanced" className="me-1" />
                            * Seg&uacute;n Ley Federal del Trabajo de M&eacute;xico (Art&iacute;culo 76)
                        </small>
                    </div>
                </div>
            )}
        </div>
    );
};

VacationSummary.propTypes = {
    calculoVacaciones: PropTypes.shape({
        diasTotales: PropTypes.number.isRequired,
        diasUtilizados: PropTypes.number.isRequired,
        diasDisponibles: PropTypes.number.isRequired,
        aniosServicio: PropTypes.number.isRequired,
        desglosePorAnio: PropTypes.arrayOf(PropTypes.shape({
            iAnio: PropTypes.number,
            vDescripcionAnio: PropTypes.string,
            dFechaInicio: PropTypes.string,
            dFechaFin: PropTypes.string,
            iDiasGenerados: PropTypes.number,
            iDiasUtilizados: PropTypes.number,
            iDiasDisponibles: PropTypes.number,
            bPeriodoActivo: PropTypes.bool,
            bPeriodoCompletado: PropTypes.bool,
            decPorcentajeAvance: PropTypes.number,
            vEstadoPeriodo: PropTypes.string
        })).isRequired
    }).isRequired,
    perfil: PropTypes.shape({
        dFechaIngreso: PropTypes.string,
        vCategoria: PropTypes.string
    }).isRequired,
    formatDate: PropTypes.func.isRequired
};

export default VacationSummary;